const doc = [({"en":({"js":({"merfoto":({"layout":({"index":({"webshop":"Webshop", "downloads":"Downloads", "orders":"Orders", "albums":"Albums", "merfoto":"MERfoto"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;